import Vue from 'vue'
import LimitDialog from '@/components/limitDialog/LimitDialog'

const mount = function () {
  const component = new Vue({
    render (h) {
      return h(LimitDialog)
    }
  })
  component.$mount()
  document.body.appendChild(component.$el)
}

export const showLimitDialog = function () {
  mount()
}
